export const dialogStyle = {
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiDialog-paper': {
    display: 'flex',
  },
};

export const dialogContentStyle = {
  minWidth: '40em',
  display: 'block',
  p: 1,
  // maxHeight: '80vh',
  '&::-webkit-scrollbar': {
    width: '0.5em',
    backgroundColor: '#F0F1F2',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#CCCCCC',
  },
};

export const serviceAgreementGroupStyle = (open: boolean) => {
  return {
    border: '1px solid',
    borderBottom: open ? 'none' : '1px solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
};

export const openedServiceAgreementGroupStyle = (open: boolean) => {
  return {
    borderBorrom: 'none',
    maxHeight: '34em',
    overflowY: 'auto',
    border: open ? '1px solid' : 'none',
    '&::-webkit-scrollbar': {
      width: '0.5em',
      backgroundColor: '#F0F1F2',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#CCCCCC',
    },
  };
};

export const documentStyle = {
  padding: '1em',
  display: 'flex',
  flexDirection: 'column',
};
export const openedAgreementStyle = () => {
  return {
    mt: 2,
    '&::-webkit-scrollbar': {
      width: '0.5em',
      backgroundColor: '#F0F1F2',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#CCCCCC',
    },
  };
};

export const openedDocumentStyle = {
  '&::-webkit-scrollbar': {
    width: '0.5em',
    backgroundColor: '#F0F1F2',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#CCCCCC',
  },
};
